var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-original-a",
    x1: 60.919,
    y1: 9.602,
    x2: 18.667,
    y2: 134.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-original-b",
    x1: 74.117,
    y1: 67.772,
    x2: 64.344,
    y2: 71.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-original-c",
    x1: 68.742,
    y1: 5.961,
    x2: 115.122,
    y2: 129.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.09.002h40.685L44.541 125.137a6.485 6.485 0 01-6.146 4.413H6.733a6.482 6.482 0 01-5.262-2.699 6.474 6.474 0 01-.876-5.848L39.944 4.414A6.488 6.488 0 0146.09 0z",
    fill: "url(#azure-original-a)",
    transform: "translate(.587 4.468) scale(.91904)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.28 81.607H37.987a2.743 2.743 0 00-1.874 4.751l38.1 35.562a5.991 5.991 0 004.087 1.61h33.574z",
    fill: "#0078d4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09.002A6.434 6.434 0 0039.93 4.5L.644 120.897a6.469 6.469 0 006.106 8.653h32.48a6.942 6.942 0 005.328-4.531l7.834-23.089 27.985 26.101a6.618 6.618 0 004.165 1.519h36.396l-15.963-45.616-46.533.011L86.922.002z",
    fill: "url(#azure-original-b)",
    transform: "translate(.587 4.468) scale(.91904)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.055 4.408A6.476 6.476 0 0091.917.002H46.575a6.478 6.478 0 016.137 4.406l39.35 116.594a6.476 6.476 0 01-6.137 8.55h45.344a6.48 6.48 0 006.136-8.55z",
    fill: "url(#azure-original-c)",
    transform: "translate(.587 4.468) scale(.91904)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.d8c693b62a434719420e95f8c65f3acd.svg";
export { ForwardRef as ReactComponent };